import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class Volcadora {
  static getVolcadorasCamiones () {
    const axios = getAxiosInstance()
    const promise = axios.get(`volcadora_camiones_listado?r=` +
    `{"orden":["nombre"]}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getVolcadorasConCerealAsignado () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_volcadora_camiones?r=` +
    `{"orden":["volcadora"]}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getVolcadorasCamionesPorVolcadora (claveVolcadora) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_volcadora_camiones_por_volcadora?r=` +
    `{"clave":{"clave_volcadora": "${claveVolcadora}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static updateVolcadora (claveVolcadora, claveSilo) {
    const axios = getAxiosInstance()
    const promise = axios.put(`volcadora`,
      `{"valores": {"silo": "${claveSilo}"}, 
    "clave": {"nombre_corto": "${claveVolcadora}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getCallesVolcadoras () {
    const axios = getAxiosInstance()
    const promise = axios.get(`calle_de_volcadora?r=` +
    `{"orden":["nombre"]}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static updateHabilitacionCalleDeVolcadora (calle, habilitado) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/calle_de_volcadora?r=`,
      `{"valores": {"habilitado": "${habilitado}"}, "clave": {"nombre_corto": "${calle}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }
}

export default Volcadora
